import { AsyncState, Fun, loadedAsyncState } from 'widgets-for-react'
import { BlogTeasersState } from '../blogs/blogTeasers/blogTeasersState'
import { ComponentTeasersState } from '../components/componentTeasers/componentTeasersState'
import { DishHighlightState } from '../dishes/dishHighlight/dishHighlightState'
import { GuestChefHighlightState } from '../guestChef/guestChefHighLight/guestChefHighLight.state'
import { KnowledgeHighlightState } from '../knowledge/knowledgeHighlight/knowledgeHighlightState'
import { loadHomeData } from './home.api'
import {
  ExtendedLoggedInHomeState,
  LoggedInHomeState,
  initialLoggedInHomeState,
} from './loggedInHome/loggedInHomeState'
import {
  ExtendedLoggedOutHomeState,
  LoggedOutHomeState,
  initialLoggedOutHomeState,
} from './loggedOutHome/loggedOutHomeState'

export type ExtendedHomeState = HomeState & {
  reloadCollections?: boolean
  searchString?: string
}

export type HomeState = {
  homeDataState: AsyncState<HomeData>
} & LoggedInHomeState &
  LoggedOutHomeState

export type HomeData = {
  blogTeasers: BlogTeasersState
  componentTeasers: ComponentTeasersState
  dishHighlight: DishHighlightState
  knowledgeHighlight: KnowledgeHighlightState
  guestChefHighlight: GuestChefHighlightState
}

export const initialHomeState: HomeState = {
  homeDataState: loadHomeData,
  ...initialLoggedInHomeState,
  ...initialLoggedOutHomeState,
}

export const homeStateUpdater =
  (
    updater:
      | Fun<LoggedInHomeState, ExtendedLoggedInHomeState>
      | Fun<LoggedOutHomeState, ExtendedLoggedOutHomeState>
  ) =>
  (state: HomeState): ExtendedHomeState => {
    const { homeDataUpdater, ...newHomeState } = updater(state)
    return {
      ...state,
      ...newHomeState,
      homeDataState:
        homeDataUpdater != undefined && state.homeDataState.kind == 'loaded'
          ? loadedAsyncState(homeDataUpdater(state.homeDataState.value))
          : state.homeDataState,
    }
  }
